/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetLoginDetailsRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {BatchGetLoginDetailsResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const batchGetLoginDetails = (request: BatchGetLoginDetailsRequest, options?: CashRequestOptions) => post<BatchGetLoginDetailsRequest, BatchGetLoginDetailsResponse>("/2.0/cash/batch-get-login-details", request, {...options, rejectOnError: true })